import { customerChatsApi } from './config/delfarApi';

export const sendChatMsg = async (chatId: string, msg: string): Promise<void> =>
    customerChatsApi.post<void>(`${chatId}/send_msg`, { text: msg }).then((r) => r.data);
